import styled from 'styled-components';
import { gray2, gray4, blue1 } from '@styles/styled/variables';

export const ButtonsWrapper = styled.div`
  background: white;
  padding: 8px;
  text-align: right;
  display: flex;
  justify-content: space-between;

  button {
    margin: 0 8px;
    line-height: 1.2;
  }

  min-height: 45px;
`;

export const Wrapper = styled.div`
  padding: 8px;
  position: relative;
  height: auto;
  display: flex;
  flex-direction: column;
  background: white;
`;

export const PageTitle = styled.h1`
  position: absolute;
  left: 16px;
  font-size: 24px;
  top: 13px;
`;

export const StyledTabs = styled.div`
  display: flex;
  margin-bottom: 10px;

  a {
    text-decoration: none;
  }
`;

export const Shares = styled.div`
  margin-top: 16px;
  padding: 0 16px;
  white-space: normal;

  table {
    font-size: 16px;
    font-weight: 300;
    width: 100%;

    td,
    th {
      border-bottom: 1px solid ${gray4};
      padding: 8px 0;
    }

    th:nth-child(1),
    th:nth-child(2) {
      padding-right: 16px;
    }

    th:nth-child(2) {
      min-width: 140px;
    }
  }
`;

export const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;

export const Border = styled.div`
  border-top: solid 2px #d9d9d9;
  width: 100%;
  padding-top: 5px;
`;

export const CollapsedItemWrapper = styled.div`
  display: flex;
  height: 50px;
  align-items: center;
  color: rgb(94 94 94);
`;

export const IndexWrapper = styled.div`
  border: solid 1px #d9d9d9;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IconWrapper = styled.div`
  border: solid 1px #d9d9d9;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 15px;
  margin-right: 15px;
  cursor: pointer;

  &:hover {
    color: ${blue1};
    border-color: ${blue1};
  }
`;

export const EarlierIndexWrapper = styled.div`
  height: 30px;
  border: solid 1px #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  color: ${blue1};
  border-color: ${blue1};
  font-weight: normal;
`;

export const CollapsedPolicyWrapper = styled.div`
  :hover {
    cursor: ${(props) => (props.sortable ? 'grab' : 'default')};
    box-shadow: ${(props) => (props.sortable ? '0px 0px 3px 3px rgba(200,200,200,0.5)' : '')};
  }

  &.ghost-version {
    background: ${gray2};
  }
`;

export const PolicyName = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
  text-align: left;
  margin-right: 15px;
`;

export const MoreVersions = styled.div`
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  color: #777;
`;
